import { FC, ReactNode } from "react";

interface SectionHeaderProps {
    title?: string;
    actionButton: ReactNode;
}

export const SectionHeader: FC<SectionHeaderProps> = ({
    title,
    actionButton,
}) => {
    return (
        <div className="flex flex-row justify-between items-center pb-3 sm:pb-4">
            {title && <div className="uppercase italic font-bold text-sky-950 text-xl sm:text-2xl lg:text-3xl xl:text-4xl" style={{ fontFamily: 'Futura, sans-serif' }}>{title}</div>}
            {actionButton}
        </div>
    )
}
